
import Icon from '../../common/Icon'

export default {
  name: 'AddressInfo',
  components: { Icon },
  props: {
    data: Object,
  },
  computed: {
    mapLink() {
      if (this.data && this.data.lat && this.data.lng) {
        return `https://maps.google.com/?q=${this.data.lat},${this.data.lng}`
      }
    }
  }
}
